/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceScopeRequestDto } from './PartnerMaintenanceScopeRequestDto';
import {
    PartnerMaintenanceScopeRequestDtoFromJSON,
    PartnerMaintenanceScopeRequestDtoFromJSONTyped,
    PartnerMaintenanceScopeRequestDtoToJSON,
    PartnerMaintenanceScopeRequestDtoToJSONTyped,
} from './PartnerMaintenanceScopeRequestDto';
import type { PartnerMaintenanceLevelRequestDto } from './PartnerMaintenanceLevelRequestDto';
import {
    PartnerMaintenanceLevelRequestDtoFromJSON,
    PartnerMaintenanceLevelRequestDtoFromJSONTyped,
    PartnerMaintenanceLevelRequestDtoToJSON,
    PartnerMaintenanceLevelRequestDtoToJSONTyped,
} from './PartnerMaintenanceLevelRequestDto';

/**
 * 
 * @export
 * @interface ReplacePartnerMaintenanceRulesRequestDto
 */
export interface ReplacePartnerMaintenanceRulesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    businessHoursStart?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    businessHoursEnd?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    workingDays: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    holidayCalendarCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    excludeHolidays?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    exclusionsText?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    recurrenceWindowDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    restoredAvailableMinutes?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    status?: ReplacePartnerMaintenanceRulesRequestDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    interventionMode?: ReplacePartnerMaintenanceRulesRequestDtoInterventionModeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    priceCurrency?: string;
    /**
     * 
     * @type {Array<PartnerMaintenanceLevelRequestDto>}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    levels: Array<PartnerMaintenanceLevelRequestDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeRequestDto>}
     * @memberof ReplacePartnerMaintenanceRulesRequestDto
     */
    scopeRules: Array<PartnerMaintenanceScopeRequestDto>;
}


/**
 * @export
 */
export const ReplacePartnerMaintenanceRulesRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED'
} as const;
export type ReplacePartnerMaintenanceRulesRequestDtoStatusEnum = typeof ReplacePartnerMaintenanceRulesRequestDtoStatusEnum[keyof typeof ReplacePartnerMaintenanceRulesRequestDtoStatusEnum];

/**
 * @export
 */
export const ReplacePartnerMaintenanceRulesRequestDtoInterventionModeEnum = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE',
    Both: 'BOTH'
} as const;
export type ReplacePartnerMaintenanceRulesRequestDtoInterventionModeEnum = typeof ReplacePartnerMaintenanceRulesRequestDtoInterventionModeEnum[keyof typeof ReplacePartnerMaintenanceRulesRequestDtoInterventionModeEnum];


/**
 * Check if a given object implements the ReplacePartnerMaintenanceRulesRequestDto interface.
 */
export function instanceOfReplacePartnerMaintenanceRulesRequestDto(value: object): value is ReplacePartnerMaintenanceRulesRequestDto {
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('workingDays' in value) || value['workingDays'] === undefined) return false;
    if (!('holidayCalendarCode' in value) || value['holidayCalendarCode'] === undefined) return false;
    if (!('levels' in value) || value['levels'] === undefined) return false;
    if (!('scopeRules' in value) || value['scopeRules'] === undefined) return false;
    return true;
}

export function ReplacePartnerMaintenanceRulesRequestDtoFromJSON(json: any): ReplacePartnerMaintenanceRulesRequestDto {
    return ReplacePartnerMaintenanceRulesRequestDtoFromJSONTyped(json, false);
}

export function ReplacePartnerMaintenanceRulesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplacePartnerMaintenanceRulesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'timezone': json['timezone'],
        'businessHoursStart': json['businessHoursStart'] == null ? undefined : json['businessHoursStart'],
        'businessHoursEnd': json['businessHoursEnd'] == null ? undefined : json['businessHoursEnd'],
        'workingDays': json['workingDays'],
        'holidayCalendarCode': json['holidayCalendarCode'],
        'excludeHolidays': json['excludeHolidays'] == null ? undefined : json['excludeHolidays'],
        'exclusionsText': json['exclusionsText'] == null ? undefined : json['exclusionsText'],
        'recurrenceWindowDays': json['recurrenceWindowDays'] == null ? undefined : json['recurrenceWindowDays'],
        'restoredAvailableMinutes': json['restoredAvailableMinutes'] == null ? undefined : json['restoredAvailableMinutes'],
        'status': json['status'] == null ? undefined : json['status'],
        'interventionMode': json['interventionMode'] == null ? undefined : json['interventionMode'],
        'priceCurrency': json['priceCurrency'] == null ? undefined : json['priceCurrency'],
        'levels': ((json['levels'] as Array<any>).map(PartnerMaintenanceLevelRequestDtoFromJSON)),
        'scopeRules': ((json['scopeRules'] as Array<any>).map(PartnerMaintenanceScopeRequestDtoFromJSON)),
    };
}

export function ReplacePartnerMaintenanceRulesRequestDtoToJSON(json: any): ReplacePartnerMaintenanceRulesRequestDto {
    return ReplacePartnerMaintenanceRulesRequestDtoToJSONTyped(json, false);
}

export function ReplacePartnerMaintenanceRulesRequestDtoToJSONTyped(value?: ReplacePartnerMaintenanceRulesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timezone': value['timezone'],
        'businessHoursStart': value['businessHoursStart'],
        'businessHoursEnd': value['businessHoursEnd'],
        'workingDays': value['workingDays'],
        'holidayCalendarCode': value['holidayCalendarCode'],
        'excludeHolidays': value['excludeHolidays'],
        'exclusionsText': value['exclusionsText'],
        'recurrenceWindowDays': value['recurrenceWindowDays'],
        'restoredAvailableMinutes': value['restoredAvailableMinutes'],
        'status': value['status'],
        'interventionMode': value['interventionMode'],
        'priceCurrency': value['priceCurrency'],
        'levels': ((value['levels'] as Array<any>).map(PartnerMaintenanceLevelRequestDtoToJSON)),
        'scopeRules': ((value['scopeRules'] as Array<any>).map(PartnerMaintenanceScopeRequestDtoToJSON)),
    };
}

